import { BLOCK_POPUP_PATHS } from 'components/popups/constants';

export const PROGRESSIVE_ONBOARDING_SOURCE = 'progressive_onboarding';

// Feature Keys
export const PS_APP_PROG_ONBOARDING_FEATURE_KEY = 'PS_APP_ONBOARDING_V1';
export const PS_APP_PROG_ONBOARDING_TOUCHLESS_FEATURE_KEY =
  'PS_APP_ONBOARDING_TOUCHLESS_V1';
export const PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY =
  'PS_APP_ONBOARDING_MANAGED_V1';
export const SHOPPER_FEATURE_KEY = 'SHOPPER_V1';
export const BUNDLED_AI_FEATURE_KEY = 'BUNDLED_AI_V1';
export const RCS_FEATURE_KEY = 'RCS_ONBOARDING_V1';

// Step Keys
export const ACTIVATE_SHOPPER_STEP_KEY = 'ACTIVATE_SHOPPER';
export const SET_UP_SHOPPER_AUTOMATIONS_STEP_KEY = 'SET_UP_SHOPPER_AUTOMATIONS';
export const AUTOMATION_ACTIVATED_MANAGED_STEP_KEY =
  'AUTOMATION_ACTIVATED_MANAGED';
export const AUTOMATION_ACTIVATED_TOUCHLESS_STEP_KEY =
  'AUTOMATION_ACTIVATED_TOUCHLESS';
export const BRAND_CENTER_SAVED_STEP_KEY = 'BRAND_CENTER_SAVED';
export const CAMPAIGN_SENT_MANAGED_STEP_KEY = 'CAMPAIGN_SENT_MANAGED';
export const CAMPAIGN_SENT_TOUCHLESS_STEP_KEY = 'CAMPAIGN_SENT_TOUCHLESS';
export const COMPLIANCE_SETTINGS_COMPLETED_STEP_KEY =
  'COMPLIANCE_SETTINGS_COMPLETED';
export const CONFIGURE_SHOPPER_STEP_KEY = 'CONFIGURE_SHOPPER';
export const CONTENT_LIBRARY_STEP_KEY = 'CONTENT_LIBRARY';
export const DEMO_SHOPPER_STEP_KEY = 'DEMO_SHOPPER';
export const INFINITY_TESTING_TRIED_STEP_KEY = 'INFINITY_TESTING_TRIED';
export const INTEGRATION_ACTIVATED_STEP_KEY = 'INTEGRATION_ACTIVATED';
export const LEARN_ABOUT_SHOPPER_STEP_KEY = 'LEARN_ABOUT_SHOPPER';
export const POPUP_ACTIVATED_MANAGED_STEP_KEY = 'POPUP_ACTIVATED_MANAGED';
export const POPUP_ACTIVATED_TOUCHLESS_STEP_KEY = 'POPUP_ACTIVATED_TOUCHLESS';
export const SUBSCRIBERS_IMPORTED_MANAGED_STEP_KEY =
  'SUBSCRIBERS_IMPORTED_MANAGED';
export const SUBSCRIBERS_IMPORTED_TOUCHLESS_STEP_KEY =
  'SUBSCRIBERS_IMPORTED_TOUCHLESS';
export const IT_CAMPAIGN_STEP_KEY = 'IT_CAMPAIGN';
export const IT_AUTOMATION_STEP_KEY = 'IT_AUTOMATION';

// RCS Onboarding Steps
export const RCS_BUILD_PROFILE_STEP_KEY = 'RCS_BUILD_PROFILE';
export const RCS_CREATE_SENDER_STEP_KEY = 'RCS_CREATE_SENDER';
export const RCS_SEND_TEST_STEP_KEY = 'RCS_SEND_TEST';
export const RCS_REQUEST_LAUNCH_STEP_KEY = 'RCS_REQUEST_LAUNCH';

// Paths
export const AUTOMATION_CONFIG_BASE_PATH = '/automations';
export const COMPLIANCE_SETTINGS_BASE_PATH = '/account/settings/compliance';
export const BUILD_CAMPAIGN_PATH = '/campaigns';
export const POPUP_CONFIG_BASE_PATH = BLOCK_POPUP_PATHS.CREATE;
export const POPUP_REVIEW_BASE_PATH = BLOCK_POPUP_PATHS.LIST;
export const INTEGRATIONS_BASE_PATH = '/integrations';
export const SUBSCRIBER_LIST_PATH = '/subscriber-list-uploads';

// Links
export const AUTOMATIONS_HELP_LINK =
  'https://help.postscript.io/hc/en-us/articles/6526853626011-Guide-to-Automation-Flows#01G57P92R608WX6B7EX0EBSX44';
export const CAMPAIGN_HELP_LINK =
  'https://help.postscript.io/hc/en-us/articles/4407853610011-Create-a-Campaign-Flow#Get-Support';
export const COMPLIANCE_OVERVIEW_LINK =
  'https://help.postscript.io/hc/en-us/articles/1260804685749-SMS-Marketing-Compliance-Overview#What-is-TCPA';
export const BRAND_CENTER_HELP_LINK =
  'https://help.postscript.io/hc/en-us/articles/27614256662555-Set-Up-Your-Brand-Center';

// Tooltip IDs
export const COMPLETE_BRAND_CENTER_STEP_TOOLTIP_ID =
  'complete-brand-center-step-tooltip';
export const ACTIVATE_SHOPPER_AUTOMATIONS_STEP_TOOLTIP_ID =
  'activate-shopper-automations-step-tooltip';

export const MANAGED_GUIDE_CUSTOM_ORDER: Record<string, number> = {
  [COMPLIANCE_SETTINGS_COMPLETED_STEP_KEY]: 1,
  [INTEGRATION_ACTIVATED_STEP_KEY]: 2,
  [BRAND_CENTER_SAVED_STEP_KEY]: 3,
  [INFINITY_TESTING_TRIED_STEP_KEY]: 4,
  [AUTOMATION_ACTIVATED_MANAGED_STEP_KEY]: 5,
  [CAMPAIGN_SENT_MANAGED_STEP_KEY]: 6,
  [POPUP_ACTIVATED_MANAGED_STEP_KEY]: 7,
  [SUBSCRIBERS_IMPORTED_MANAGED_STEP_KEY]: 8,
};

export const CUSTOM_SORT_ORDERS: Record<string, Record<string, number>> = {
  [PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY]: MANAGED_GUIDE_CUSTOM_ORDER,
};

export const SHOPPER_WORKFLOW_HIDDEN_KEY = `progressive_onboarding_${SHOPPER_FEATURE_KEY}_hidden`;

export const BUNDLED_AI_WORKFLOW_HIDDEN_KEY = `progressive_onboarding_${BUNDLED_AI_FEATURE_KEY}_hidden`;
